// extracted by mini-css-extract-plugin
export default {"icon":"IlRvzz","icon__image":"oTHH73","icon__image_mode_mask":"QGlKAe","icon__image_mode_background":"uVpFJ6"};